import { isMobile } from "react-device-detect";
import { WalletOption as WalletOptionType } from "@silo/types";
import { getIsCoinbaseWallet, getIsInjected, getIsMetaMask } from "./utils";
import { coinbaseLink, metaMaskLink } from "./wallets";

/**
 * @deprecated
 *
 * TODO: remove this logic
 *
 */
export function getWalletOptions(): WalletOptionType[] {
  const isInjected = getIsInjected();
  const isMetaMask = getIsMetaMask();
  const isCoinbaseWallet = getIsCoinbaseWallet();

  const isCoinbaseWalletBrowser = isMobile && isCoinbaseWallet;
  const isMetaMaskBrowser = isMobile && isMetaMask;
  const isInjectedMobileBrowser = isCoinbaseWalletBrowser || isMetaMaskBrowser;

  let injectedOption: WalletOptionType | undefined;
  if (!isInjected) {
    if (!isMobile) {
      injectedOption = { walletKey: "metaMask", href: metaMaskLink.href };
    }
  } else if (!isCoinbaseWallet) {
    injectedOption = { walletKey: "metaMask", href: null };
    // supported injected option?
    // if (isMetaMask) {
    //   injectedOption = metaMaskWallet;
    // } else {
    // }
  }

  let coinbaseWalletOption: WalletOptionType | undefined;
  if (isMobile && !isInjectedMobileBrowser) {
    coinbaseWalletOption = { walletKey: "coinbase", href: coinbaseLink.href };
  } else if (!isMobile || isCoinbaseWalletBrowser) {
    coinbaseWalletOption = { walletKey: "coinbase", href: null };
  }

  let walletConnectionOption: WalletOptionType | undefined;

  if (!isInjectedMobileBrowser) {
    walletConnectionOption = { walletKey: "walletConnect", href: null };
  }

  const walletOptions = [
    injectedOption,
    coinbaseWalletOption,
    walletConnectionOption,
  ].flatMap((option) => (option ? [option] : []));

  return walletOptions;
}
